import React from 'react';

export default function TermsAndConditions() {
  return (
    <div>
      <p>
        Estos TÉRMINOS Y CONDICIONES regulan el uso que los usuarios hagan de la aplicación y cualquier servicio brindado por la misma. Al hacer uso
        de Check, aceptas estos términos y condiciones, así como futuros cambios y actualizaciones del software. Estos Términos y Condiciones serán
        siempre aplicables a todo el contenido relativo a la esta aplicación, y la empresa se reserva el derecho a modificarlos, alterarlos o
        actualizarlos en cualquier momento unilateralmente. Al usar nuestros servicios, aceptas estos Términos en su totalidad.
      </p>
      <h4>QUIENES PUEDEN USAR NUESTROS SERVICIOS</h4>
      <p>
        Solamente pueden usar nuestros servicios aquellos profesores (y sus respectivos alumnos) que cumplan con el registro debido y abonen la cuota
        correspondiente al servicio brindado.
      </p>
      <h4>USO DE LA APLICACIÓN Y DERECHOS DE AUTOR</h4>
      <p>
        Al contratar con Check, los profesores adquieren el derecho a subir el material de estudio que crea conveniente a los efectos de su curso,
        siendo ellos total y completamente responsables de las posibles infracciones a los derechos de autor que puedan cometer. Check no es
        responsable del material en línea, por tanto, de ninguna forma se responsabiliza por los archivos subidos por los usuarios de nuestro
        servicio. Si considera que se ha encontrado con algún archivo que está infringiendo derechos de autor, por favor comunicarlo a
        contacto@tesalve.uy. El mismo será revisado por Check y tomará las medidas necesarias a tal respecto.
      </p>
      <h4>CURSOS Y CONTENIDO</h4>
      <p>
        Los cursos son creados y supervisados por los profesores. Check no guarda ninguna responsabilidad relacionada con los cursos ofrecidos por
        nuestros usuarios, por ende, no puede asegurar que el contenido de los mismos pueda resultar inapropiado para quienes hagan uso de la
        aplicación, así como perjudicial para la computadora o Smartphone que utilice la aplicación. No obstante, Check se reserva el derecho de
        cancelar cualquier curso o su contenido, así como los cuestionarios o cualquier otro método de evaluación implementado por la aplicación. Los
        usuarios no ceden la propiedad de los materiales de estudio que suben a la plataforma. Este contrato no habilita a TeSavlé a utilizar los
        materiales aportados por los profesroes a otros efectos que los propios de los respectivos cursos; por ende, su utilización se agota en tales
        fines. Check no garantiza el éxito académico de los estudiantes que utilicen la aplicación. Los registros que se generen a partir del uso de
        la aplicación, como los resultados obtenidos en las evaluaciones, podrán ser utilizados por Check con fines estadísticos, informativos o de
        cualquier otro tipo.
      </p>
      <h4>FEEDBACK</h4>
      <p>
        Cualquier opinión o sugerencia (&quot;feedback&quot;) podrá ser enviada a la dirección proporcionada por la aplicación para tales efectos. Al
        enviar dicha opinión, nos concedes el derecho a usarla sin ningún tipo de limitación, compensación, resarcimiento, indemnización alguna hacia
        tí. Si Check aceptara las ideas u opiniones, no renuncia al derecho de usar opiniones similares o relacionadas, obtenidas de cualquier fuente.
      </p>
      <h4>SEGURIDAD Y SOPORTE</h4>
      <p>
        Check no puede garantizar que terceros de forma no autorizada puedan obtener información respecto de las cuentas de nuestros usuarios. En caso
        de que entienda que se ha producido un uso no autorizado de alguna cuenta, puede contactarse con nuestro servicio técnico en
        contacto@tesalve.uy (casilla de correo).
      </p>
      <h4>LIMITACIÓN DE RESPONSABILIDAD</h4>
      <p>
        Check no es responsable de ninguna manera, ni ofrece garantía alguna por cualquier uso de nuestro servicio, tanto en lo relativo a sus cursos
        como respecto al acceso a la plataforma o la información de usuario, no agotándose en los ejemplos todo lo que abarca el uso relacionado a la
        aplicación. No se responsabiliza Check por ello, por daños de ningún tipo o por cualquier pérdida de beneficios o ingresos que puedan resultar
        de la prestación de nuestro servicio. Aceptas que las limitaciones de responsabilidad acordadas en este documento, son razonables y necesarias
        para que Check pueda funcionar de forma económicamente viable.
      </p>
    </div>
  );
}
